import { ActionButton } from "@fluentui/react"

export default function ChatButton() {
    return <ActionButton
        iconProps={{ iconName: "Chat" }}
        onClick={() => { window.open("https://t.me/arina_sale", "_blank") }}
    >Chat</ActionButton>
}